import React from 'react'
import { Box } from 'front-end/src/components'
import { Plural, Trans } from '@lingui/macro'
import Message, {
  MessageTypes
} from 'front-end/src/components/common/message/Message'
import { linkBuilder } from 'shared/linkBuilder'
import {
  RelatedInstanceItem,
  RelatedInstancesWrapper
} from 'front-end/src/components/common/related-instances/RelatedInstances'
import IconEnergy from 'front-end/src/components/common/icon/IconEnergy'
import { brandColors } from 'shared/basicPalette'
import IconExclamation from 'front-end/src/components/common/icon/IconExclamation'

export const EventUsedInCampaignsWarning = ({ relatedCampaigns }) => {
  if (!relatedCampaigns || relatedCampaigns?.length === 0) {
    return null
  }

  return (
    <Box className="Modal__relatedItems" pb="16px">
      <Message type={MessageTypes.ERROR} mb="24px">
        <IconExclamation mr="8px" />
        <Trans>
          This event is used in the audience criteria of the following
          campaigns. Deleting this event will update these campaigns and will
          stop campaigns with this event only.
        </Trans>
      </Message>

      <RelatedInstancesWrapper>
        {relatedCampaigns.map((campaign) => {
          return (
            <RelatedInstanceItem
              key={`campaign-${campaign.id}`}
              id={campaign.id}
              href={`${linkBuilder.campaign(campaign.id)}`}
              icon={<IconEnergy color={brandColors.grey.mid} />}
              name={campaign.name}
              additionalInfo={
                <Plural
                  one="# action"
                  other="# actions"
                  value={campaign.actionsCount}
                />
              }
            />
          )
        })}
      </RelatedInstancesWrapper>
    </Box>
  )
}
